import { createCorrelationId } from '@core/domain/utils/correlationId.ts';
import { assertLocalStorageHeadroomForMedia } from '@src/modules/platform/local-media/domain/localStorageHeadroom.ts';

export type VerifiedMediaBlobPort = {
  put(id: string, blob: Blob): Promise<void>;
  get(id: string): Promise<Blob | null>;
  delete(id: string): Promise<void>;
};

export async function persistVerifiedMediaBlob(
  media: VerifiedMediaBlobPort,
  blob: Blob,
  label: string,
  currentId?: string | null,
): Promise<string> {
  if (!blob.size) throw new Error(`${label}: el archivo está vacío.`);
  await assertLocalStorageHeadroomForMedia();
  const nextId = createCorrelationId();
  await media.put(nextId, blob);
  const stored = await media.get(nextId);
  if (!stored?.size) {
    await media.delete(nextId).catch(() => {});
    throw new Error(`No se pudo verificar ${label.toLowerCase()} en el dispositivo. Intente de nuevo.`);
  }
  if (currentId?.trim()) await media.delete(currentId);
  return nextId;
}

export async function assertVerifiedMediaStored(
  media: VerifiedMediaBlobPort,
  mediaId: string | null | undefined,
  label: string,
): Promise<void> {
  const id = mediaId?.trim();
  if (!id) throw new Error(`${label}: referencia faltante.`);
  const stored = await media.get(id);
  if (!stored?.size) throw new Error(`${label}: no está guardada en el dispositivo.`);
}

export async function resolveVerifiedMediaId(
  media: VerifiedMediaBlobPort,
  blob: Blob | null,
  currentId: string | null | undefined,
  label: string,
): Promise<string> {
  if (blob) return persistVerifiedMediaBlob(media, blob, label, currentId);
  const id = currentId?.trim() ?? '';
  if (id) await assertVerifiedMediaStored(media, id, label);
  return id;
}
